import { memo } from "react";

function BeRightBack() {
  return (
    <>
      <div
        id="attendeehostdisconnect"
        className="attendee-host-disconnect"
        style={{ display: "flex" }}
      >
        <div className="attendee-host-disconnect-wrraper">
          <div className="watch-icon">
            <i className="icon font-awesome-light-pro va-waiting"></i>
          </div>
          <h4 className="disconnect-title">Be Right Back!</h4>
          <p className="disconnect-txt">Waiting for instructor to rejoin.</p>
        </div>
        <div
          id="divHostDisconnectAttendeeViewChange"
          style={{ display: "none" }}
          className="change-view hot-slider-view hide-on-mobileOnly attGalleryTooltip"
        >
          {/* <!--hide-on-mobile tooltip--> */}
          <i className="icon font-awesome-light-pro va-border-all "></i>
          <span id="viewTypeAttendee" className="tooltiptext">
            Gallery View{" "}
          </span>
        </div>
      </div>
    </>
  );
}
export default memo(BeRightBack);
